var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00967 18.8724H11.0097C12.1142 18.8724 13.468 18.1032 14.0335 17.1543L16.5089 13L21.0097 13C21.562 13 22.0097 12.5523 22.0097 12C22.0097 11.4478 21.562 11 21.0097 11L16.4138 11L13.9383 6.84575C13.3729 5.89687 12.0191 5.12765 10.9145 5.12765L8.91454 5.12765L12.4138 11H5.42485L3.99036 8.54717H1.99036L4.00967 12L4.00967 12.0331L2.00967 15.4529H4.00967L5.44417 13L12.5089 13L9.00967 18.8724Z",
    fill: "#7E8A96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.ab984093.svg";
export { ForwardRef as ReactComponent };